import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const CART_KEY = "moatazCart";

function readCart() {
  try {
    return JSON.parse(localStorage.getItem(CART_KEY)) || [];
  } catch (error) {
    return [];
  }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(readCart);

  useEffect(() => {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const subtotal = items.reduce((sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 1), 0);
    return {
      items,
      count: items.reduce((sum, item) => sum + Number(item.quantity || 1), 0),
      subtotal,
      add(product, quantity = 1) {
        const price = Number(product.discount_price || product.price || 0);
        setItems((current) => {
          const existing = current.find((item) => item.id === product.id);
          if (existing) {
            return current.map((item) => item.id === product.id ? { ...item, quantity: item.quantity + quantity } : item);
          }
          return [...current, {
            id: product.id,
            slug: product.slug,
            name: product.name,
            image_url: product.image_url,
            price,
            original_price: Number(product.price || price),
            quantity,
          }];
        });
      },
      remove(id) {
        setItems((current) => current.filter((item) => item.id !== id));
      },
      update(id, quantity) {
        setItems((current) => current.map((item) => item.id === id ? { ...item, quantity: Math.max(1, Number(quantity || 1)) } : item));
      },
      clear() {
        setItems([]);
      },
    };
  }, [items]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  return useContext(CartContext);
}
